import { createFileRoute } from '@tanstack/react-router'
import { trpc } from '@/main'
import { noop } from '@tanstack/react-query'

// Pathless layout that OWNS the search-keyed list query, so `q`/`type` re-key THIS match and not the section root
// above it — the root paints the section skeleton at `pendingMs: 0`, and a re-key there would swap the rail for the
// skeleton on every debounced keystroke, unmounting the search box (see jobs._list.tsx). The invitations query stays
// on the root: nothing in the URL keys it. The panels read this match with `useMatch({ from: '/_app/employees/_list' })`.
export const Route = createFileRoute('/_app/employees/_list')({
  loaderDeps: ({ search }) => ({ type: search.type, q: search.q }),
  // The list's key, search included. `q` already lives in the URL (the search box writes it), so it belongs in
  // `loaderDeps` — the loader and both panels then read the ONE object built here and there is no searched variant
  // for a component to mint. `type` is sent to the resolver so each row carries a pre-selected `hasCurrentTest`.
  context: ({ deps }) => ({
    employeesInfiniteQueryOptions: trpc.employees.getEmployeesInfinite.infiniteQueryOptions(
      { q: deps.q || undefined, type: deps.type },
      { getNextPageParam: (lastPage) => lastPage.nextCursor },
    ),
  }),
  loader: ({ context }) => {
    context.queryClient.infiniteQuery(context.employeesInfiniteQueryOptions).catch(noop)
  },
})
